import axios from 'axios';

// Production backend for native APK / iOS builds. This is the source of
// truth when REACT_APP_BACKEND_URL is missing at build time (the common
// failure mode for Capacitor APKs — relative paths resolve to
// https://localhost inside the WebView and never reach our backend).
//
// iter-116: was `becaim.bizil.app` which stopped serving SSL after the
// domain migration → every native OTP / Google-Sign-In / feed call
// failed with `ERR_NETWORK`. Point at the current primary production
// domain (`becaim.app`) so re-built native apps recover immediately.
const PRODUCTION_API_FALLBACK = 'https://becaim.app';

// Detect Capacitor native shell (Android / iOS APK / IPA).
// `window.Capacitor` is injected by the runtime; `isNativePlatform()` is
// the documented predicate.
function isCapacitorNative() {
  try {
    return !!(typeof window !== 'undefined'
      && window.Capacitor
      && (window.Capacitor.isNativePlatform
        ? window.Capacitor.isNativePlatform()
        : window.Capacitor.getPlatform && window.Capacitor.getPlatform() !== 'web'));
  } catch {
    return false;
  }
}

// Resolve the backend origin in this order:
//  1. Native shell → ALWAYS production (relative paths would hit localhost).
//  2. Explicit REACT_APP_BACKEND_URL → use it.
//  3. Empty/missing env → production fallback so a mis-built bundle still works.
function resolveBackendUrl() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (isCapacitorNative()) return PRODUCTION_API_FALLBACK;
  if (fromEnv && /^https?:\/\//i.test(fromEnv)) return fromEnv.replace(/\/+$/, '');
  return PRODUCTION_API_FALLBACK;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith('/login')) {
        localStorage.removeItem('gm_token');
        localStorage.removeItem('gm_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
